import Marquee from "react-fast-marquee";
import { locations } from "@/data/landingData";
import { usePricing } from "@/lib/pricing";

export function MarqueeSection() {
  const { items } = usePricing();
  return (
    <section className="py-8 bg-[#0a0a0a] border-y border-white/5 overflow-hidden">
      <Marquee speed={40} gradient={false}>
        {[...items, ...items].map((item, i) => (
          <span key={`${item.slug}-${i}`} className="marquee-text mx-16">
            {item.title}{" "}
            <span className="text-[#00E5FF]">
              {Number.isInteger(item.rate) ? item.rate : Number(item.rate).toFixed(2)}
              {item.unit}
            </span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}

export function LocationsMarquee() {
  return (
    <section className="py-12 section-surface border-y border-white/5">
      <p className="text-center mono text-xs text-zinc-500 uppercase tracking-[0.2em] mb-8">
        Pôsobíme v
      </p>
      <Marquee speed={30} gradient={false}>
        {[...locations, ...locations].map((loc, i) => (
          <span
            key={i}
            className="text-4xl sm:text-5xl font-black text-white/10 mx-8 tracking-tight"
          >
            {loc}
          </span>
        ))}
      </Marquee>
    </section>
  );
}
